import React, { useState, useEffect } from "react";
import { SetHeading } from "../../context/NavbarContext";
import { Breadcrumb, Button, ConfigProvider, DatePicker, Select } from "antd";
import { DoubleRightOutlined, DownloadOutlined } from "@ant-design/icons";
import ShimmerLoader from "../../loading";
import "../../styles.css";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation } from "react-router-dom";
import { routes } from "../../Routes";
import LoadingSpinner from "../../components/Loading";
import {
  fetchAllVendors,
  getVendors,
} from "../../API  Functions/PurchaseFunctions";
import SearchBox from "../../components/CustomWidgets/SearchBox";
import { debounce } from "@mui/material";
import { GetItemWiseSaleData } from "../../API  Functions/SessionHistoryFunctions";
import CreditHistoryTable from "./CreditHistoryTable";
import CashiInOutTable from "./CashInOutTable";
import { getStoreUsers } from "../../API  Functions/UserMangement";
import PosOrderTable from "./PosOrdersTable";
import SaleSummaryTable from "./SaleSummaryTable";
import SelectBox from "../../components/CustomWidgets/SelectBox";
import moment from "moment";
import dayjs from "dayjs";
import ExportCasInOutReportModal from "./ExportCasInOutReportModal";
import i18next from "i18next";
import axiosInstance from "../../AxiosInstance";
import { URLS } from "../../API/API endpoints";
import { toast } from "react-toastify";
import DateFilter from "../../components/ui/DateFilter";
import ItemWiseSaleTable from "./ItemWiseSaleTable";
import { checkPermission } from "../../Utils/permissionHelper";

const ItemWiseSale = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const [loading, setloading] = useState(false);
  const { Option } = Select;
  const [data, setData] = useState([]);
  const [currentLimit, setCurrentLimit] = useState(20); // Default limit
  const [currentOffset, setCurrentOffset] = useState(0); // Default offset
  const [query, setquery] = useState("");
  const [cashiInOutData, setCashiInOutData] = useState([]);
  const [userData, setUserData] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [salesData, setSalesData] = useState([]);
  const company_id = useSelector(
    (state) => state?.login?.user?.result?.company_id
  );
  const isGinne = useSelector(
    (state) => state?.geneLoginReducer?.isGinneLogin
  );
  const today = dayjs();
  const formatToday = today.format("YYYY-MM-DD");
  const startofMonth = today.startOf("month").format("YYYY-MM-DD");
  const [selectedRange, setSelectedRange] = useState("thisMonth");

  const [startDate, setStartDate] = useState(startofMonth);
  const [endDate, setEndDate] = useState(formatToday);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  const GetSaleData = async (limit, offset, start, end) => {
    const payload = {
      // user_id: user_id,
      company_id: company_id,
      offset: offset,
      limit: limit,
      start_date: start,
      end_date: end,
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
    };
    try {
      const res1 = await GetItemWiseSaleData(payload);

      if (res1?.result?.status_code === 200) {
        setloading(false);
        setSalesData(res1?.result?.data);
      } else {
        setloading(false);
        setSalesData([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      setloading(false);
    } finally {
      setloading(false);
    }
  };

  const handleExport = async (dates) => {
    let payload = {
      lang: i18next.language === "ar" ? "ar_001" : "en_US",
      start_date: dates?.startDate,
      end_date: dates?.endDate,
      // user_id:  user_id,
      company_id: company_id,
      // search: "",
    };
    const response = await axiosInstance.post(
      URLS.GET_ITEM_WISE_SALE_EXCEL,
      payload
    );
    console.log("handleExport", response);
    if (response?.data?.result?.status_code == 200) {
      setExportModalOpen(false);
      downloadFile(response?.data?.result?.file_data);
    } else {
      toast.error(response?.data?.result.status);
    }
  };

  const downloadFile = (base64Data) => {
    try {
      if (
        !base64Data ||
        typeof base64Data !== "string" ||
        base64Data.trim() === ""
      ) {
        alert("No valid file data available for download");
        return;
      }

      let cleanBase64 = base64Data
        .trim()
        .replace(/^data:[\w/+-]+;base64,/, "")
        .replace(/^["']|["']$/g, "")
        .replace(/\s/g, "");

      const padLength = 4 - (cleanBase64.length % 4);
      if (padLength < 4) cleanBase64 += "=".repeat(padLength);

      let binaryString = atob(cleanBase64);
      const bytes = new Uint8Array(binaryString.length);
      for (let i = 0; i < binaryString.length; i++) {
        bytes[i] = binaryString.charCodeAt(i);
      }

      const header = new Uint8Array(bytes.buffer, 0, 8);
      let mimeType = "application/octet-stream";
      let fileExtension = "bin";

      if (header[0] === 0x50 && header[1] === 0x4b) {
        mimeType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        fileExtension = "xlsx";
      } else if (
        header[0] === 0xd0 &&
        header[1] === 0xcf &&
        header[2] === 0x11 &&
        header[3] === 0xe0
      ) {
        mimeType = "application/vnd.ms-excel";
        fileExtension = "xls";
      } else if (new TextDecoder().decode(header).includes(",")) {
        mimeType = "text/csv";
        fileExtension = "csv";
      }

      const blob = new Blob([bytes], { type: mimeType });
      const timestamp = moment().format("YYYY-MM-DD_HH.mm.ss"); // Using period for time
      const filename = `${t("item_wise_sales")}_${timestamp}.${fileExtension}`;
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }, 100);
    } catch (error) {
      console.error("File download failed:", error);
      alert(`Download failed: ${error.message || "Unknown error"}`);
    }
  };

  return (
    <>
      <div className="w-full flex flex-col md:h-full pb-2 overflow-y-auto  bg-[#F6F7F9]">
        <SetHeading value="Item-wise Sales" />
        <div className="flex-grow overflow-y-auto custom-scrollbar overflow-hidden ms-3">
          {/* <div className="font-extrabold mb-3">
                        <Breadcrumb
                            separator={<DoubleRightOutlined />}
                            items={[
                                {
                                    title: <Link to={routes.cashier}>{t("Cashier")}</Link>,
                                    key: "purchase",
                                },
                                { title: t("Item-wise Sales") },
                            ]}
                            className="relative mt-3 font-semibold"
                        />
                    </div> */}
          <div className="flex justify-between items-center me-8 mt-3">
            <DateFilter
              setSelectedRange={setSelectedRange}
              selectedRange={selectedRange}
              SubmitFilter={(start, date) => {
                setStartDate(start);
                setEndDate(date);
                GetSaleData(20, 0, start, date);
              }}
            />
            <button
              className="w-48 h-10 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2"
              // onClick={() => setExportModalOpen(true)}
              onClick={() => {
                if (checkPermission("/pos/salesummary", isGinne)) {
                  setExportModalOpen(true);
                }
              }}
            >
              <DownloadOutlined
                style={{ fontSize: "1.5em", MozMarginStart: -10 }}
              />

              <span>{t("Download in Excel")}</span>
            </button>
          </div>
          {loading ? (
            <ShimmerLoader />
          ) : (
            <>
              <div className=" mt-5">
                <ItemWiseSaleTable
                  additionalData={salesData}
                  pagination={(values) => {
                    // setloading(true)
                    GetSaleData(
                      values.limit,
                      values.offset,
                      startDate,
                      endDate
                    );

                    setCurrentLimit(values.limit);
                    setCurrentOffset(values.offset);
                  }}
                />
              </div>
            </>
          )}
        </div>
        {exportModalOpen && (
          <ExportCasInOutReportModal
            heading={t("Download Item-Wise Sales")}
            isOpen={exportModalOpen}
            onClose={() => setExportModalOpen(false)}
            onExport={(dates) => handleExport(dates)}
          />
        )}
      </div>
    </>
  );
};

export default ItemWiseSale;
